module.exports = __webpack_public_path__ + "img/lg_ring_0_0_1_0@2x.5965eaa7.png";